import getInitialState from './initialState';
export default {
    enableKeyboard: state => Object.assign(state, { enabled: true }),
    disableKeyboard: state => Object.assign(state, { enabled: false }),
    showKeyboard(state, { enable = false } = {}) {
        Object.assign(state, { show: true });
        if (enable) {
            Object.assign(state, { enabled: true });
        }
    },
    setCapsLock: (state, value) => {
        Object.assign(state, { capsLock: value });
    },
    hideKeyboard: state => Object.assign(state, {
        show: false,
        enabled: false
    }),
    pressHoldKey: state => Object.assign(state, { holdKeyPressed: true }),
    releaseHoldKey: state => Object.assign(state, { holdKeyPressed: false }),
    toggleSpecialKeys: state => Object.assign(state, { showSpecialKeys: !state.showSpecialKeys }),
    configureKeyboard: (state, settings) => Object.assign(state, { settings }),
    resetKeyboard: state => Object.assign(state, Object.assign({}, getInitialState())),
    disableTopLevelInput: state => Object.assign(state, { topLevelInput: false }),
    enableTopLevelInput: state => Object.assign(state, { topLevelInput: true }),
};
